import { FC } from 'react'
import type { Product } from '@commerce/types'
import ProductTags from '../ProductTags'
import ProductTagSpecificationsTable from '@components/product/ProductTagsSpecificationsTable'
import ProductDescription from '@components/product/ProductDescription'

interface Props {
  product: Product.Product
}

const ProductDetails: FC<Props> = ({ product }) => {
  return (
    <div className="lg:mt-16 mt-10 w-full">
      <div className="text-label font-bold py-2 uppercase text-ui-darkest-grey">
        Product Details
      </div>
      <h4 className="text-label font-normal text-ui-grey-50">
        SKU: {product.variants[0].sku}
      </h4>
      <ProductTags product={product} />
      <ProductDescription product={product} />
      <div className="lg:mt-8 mt-4">
        <ProductTagSpecificationsTable tags={product.tags} />
      </div>
    </div>
  )
}

export default ProductDetails
